import { render } from "./VoteLayout.vue?vue&type=template&id=7bf5d058"
import script from "./VoteLayout.vue?vue&type=script&lang=js"
export * from "./VoteLayout.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__